export default [
  'file',
  'type',
  'identifier',
  'title',
  'description',
  'value',
  'tableColumnOrder',
  'tableColumns',
  'rowOrder',
  'yTitle',
  'yMin',
  'yMax',
  'xTitle',
  'xMin',
  'xMax',
  'options',
  'multi',
  'required',
  'hidden',
  'logic',
  'metadata',
  'signer',
  'tipTitle',
  'tipDescription',
  'tipVisible'
];
